import { useEffect, useState } from 'react';

import { getBookingUrl } from '@/lib/helpers';

/** URL de prise de rendez-vous du calendrier `slug`, chargée à la demande. */
const useBookingUrl = (slug: string, params: Record<string, string> = {}, enabled = true): string | null => {
    const [bookingUrl, setBookingUrl] = useState<string | null>(null);
    const paramsKey = JSON.stringify(params);

    useEffect(() => {
        if (!enabled) return;

        let cancelled = false;

        void getBookingUrl(slug, JSON.parse(paramsKey) as Record<string, string>).then((url) => {
            if (!cancelled) setBookingUrl(url);
        });

        return () => {
            cancelled = true;
        };
    }, [slug, paramsKey, enabled]);

    return bookingUrl;
};

export default useBookingUrl;
